module.exports = __webpack_public_path__ + "static/media/grad5.afa462e7.jpg";